import { render } from "./Stocks.vue?vue&type=template&id=814e5e12&scoped=true"
import script from "./Stocks.vue?vue&type=script&lang=js"
export * from "./Stocks.vue?vue&type=script&lang=js"

import "./Stocks.vue?vue&type=style&index=0&id=814e5e12&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-814e5e12"]])

export default __exports__